import { type FC } from 'react'

import { useIntercom } from 'react-use-intercom'

import background from '@/assets/icons/chrismas/ch_gift.webp'
import communityIcon from '@/assets/icons/chrismas/chat-icon_ch_cr.webp'
import doDontIcon from '@/assets/icons/chrismas/dont_ch_cr.webp'
import laptopIcon from '@/assets/icons/chrismas/laptop-icon_ch_cr.webp'
import lights from '@/assets/icons/chrismas/lights.webp'
import OFIcon from '@/assets/icons/chrismas/onlyfans_icon_ch_cr.webp'
import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import type { DialogProps } from '@/dialogs/types'

const bonuses = [
  {
    icon: OFIcon,
    title: 'Supervisor Training',
    description: 'How to do Chatting Feedback',
    label: 'Loom Video',
  },
  {
    icon: laptopIcon,
    title: 'Growth Analysis',
    description: 'How to do a New Subscriber Analysis',
    label: 'Loom Video',
  },
  {
    icon: communityIcon,
    title: 'Chatting Training',
    description: 'Structure, Smalltalk & Selling Process',
    label: 'PDF',
  },
  {
    icon: doDontIcon,
    title: "DO's & DONT's",
    description: 'Expectations & Guidelines',
    label: 'PDF',
  },
]

export const Christmas2025PromotionDialog: FC<DialogProps> = ({
  isOpen,
  onClose,
}) => {
  const intercom = useIntercom()

  const handleClickNewLicense = () => {
    intercom.showNewMessage('I want to claim my FREE Christmas gift 🎁')
    onClose()
  }

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
      panelClassName="max-h-[calc(100vh-32px)] max-[390px]:max-h-[calc(100vh-16px)] flex flex-col lg:max-w-[800px] bg-[#0A0C16] sm:max-w-[634px] sm:p-9 p-6 lg:pt-0 rounded-2xl"
      closeIconClassName="p-2 z-20 rounded-full bg-white/10 [&_svg]:text-white [&_svg]:h-6 [&_svg]:w-6 h-10 w-10"
      containerClassName="items-center max-[390px]:p-2"
      childrenClassName="max-h-full overflow-y-auto flex flex-col"
    >
      <div className="relative z-10 h-[292px] shrink-0 max-[390px]:h-[234px] flex items-center justify-center overflow-hidden">
        <img
          src={background}
          alt="New Year promotion background"
          className="h-[300px]"
        />
        <img
          src={lights}
          alt="lights"
          className="h-[30px] absolute"
        />
        <div className="absolute z-10 shadow-[0_0_40px_20px_#0A0C16_inset] inset-0" />
      </div>
      <div className="z-10 relative -mt-12 min-[390px]:-mt-14 flex flex-col items-center shrink-0">
        <h2 className="text-center text-xl sm:text-[32px] sm:leading-10 font-semibold text-white">
          Unwrap Your Free
        </h2>
        <h2 className="text-center text-xl sm:text-[32px] sm:leading-10 font-semibold text-white">
          Creator Success Bundle
        </h2>
        <p className="text-[#898C9A] text-base sm:text-lg font-semibold mt-2 sm:mt-4 text-center">
          To celebrate the holidays, we&#39;ve unlocked exclusive training
          resources for you. Master your workflow and start strong in 2026.
        </p>
        <div className="mt-4 sm:grid sm:grid-cols-2 sm:grid-rows-2 flex flex-col gap-4 bg-[linear-gradient(0deg,rgba(24,57,156,0.20)_-6.22%,rgba(5,10,29,0.00)_76.49%)] bg-[rgba(1,4,22,0.50)] w-full p-4 pr-0 sm:p-6 rounded-[20px] border border-[#1E2D50] shadow-[0_0_25px_0rgba(20,36,73,0.50)_inset]">
          {bonuses.map(({ icon, title, description, label }) => (
            <div
              className="flex items-center gap-4"
              key={title}
            >
              <img
                className="h-10 w-10"
                src={icon}
                alt={title}
              />
              <div>
                <div className="flex flex-wrap gap-1 mb-1 items-center">
                  <p className="text-md font-medium text-white">{title}</p>
                  <span className="text-white text-[10px] sm:text-xs max-h-[24px] sm:max-w-[85px] font-medium bg-white/10 rounded-2xl px-1.5 sm:px-2 py-0.5 flex items-center justify-center gap-2 shrink-0">
                    {label}
                  </span>
                </div>
                <p className="text-sm font-medium text-[#898C9A]">
                  {description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Button
        className="w-full mt-8 min-h-[40px] text-lg rounded-full p-3 bg-[#CC2030] hover:bg-[#CC2030]/80 font-semibold"
        onClick={handleClickNewLicense}
      >
        Claim Free Gift Bundle
      </Button>
      <div className="flex items-center justify-center gap-2 text-[#9CA3B8] mt-4">
        <div className="w-2 h-2 rounded-full bg-green-500" />
        <span className="text-sm">
          Support is online to send you gift immediately.
        </span>
      </div>
    </Dialog>
  )
}
